<h2 mat-dialog-title>
  @if (erMappe) {
    {{"Flytt mappen '{navn}'"|translate:{navn: nodeSomFlyttes.navn} }}
  } @else {
    {{"Flytt dokumentet '{navn}'"|translate:{navn: nodeSomFlyttes.navn} }}
  }
</h2>
<mat-dialog-content>
  <p>{{ "Velg hvilken mappe du ønsker å flytte til" | translate }}</p>
  <arkiv-velg-node [gruppeId]="nodeSomFlyttes.eiendeGruppeId" [kanVelges]="kanNodeVelgesFn()" [initieltValgt]="nodeSomFlyttes.forelder!" [kontroll]="maalMappKontroll"/>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <div>
    <p data-testid="bekrefttekst">
      &nbsp; <!-- slik at <p> opptar vertikal plass selvom ingen tekst vises -->
      @if (maalMappKontroll.valid) {
        @if (erMappe) {
          {{ "Du er i ferd med å flytte mappen '{kildenavn}' til '{maalnavn}'"|translate:{kildenavn: nodeSomFlyttes.navn, maalnavn: maalMappKontroll.value.navn} }}
        } @else {
          {{ "Du er i ferd med å flytte dokumentet '{kildenavn}' til '{maalnavn}'"|translate:{kildenavn: nodeSomFlyttes.navn, maalnavn: maalMappKontroll.value.navn} }}
        }
      }
    </p>
    @if(feilmelding()){
      <inline-melding type="feil">{{feilmelding()}}</inline-melding>
    }
    <div>
      <button mat-button (click)="avbryt()">{{ "Avbryt"|translate }}</button>
      <button mat-raised-button color="primary"
              (click)="flytt()"
              [disabled]="maalMappKontroll.invalid"
              [visSpinner]="lagrer()" spinnerTekst="{{'Flytter...'|translate}}"
              data-testid="lagre-knapp"
              cdkFocusInitial>
        {{ "Flytt"|translate }}
      </button>
    </div>
  </div>
</mat-dialog-actions>
